import React from 'react'

const StopLinkSuccessPage = () => {
  return (
    <>
      <h1>Successfuly Unsubscribe</h1>
    </>
  )
}

export default StopLinkSuccessPage
